const _ = require('./enum');
module.exports = {
  [_.AUTHORIZE]: { id: _.AUTHORIZE, label: 'Authorize' },
  [_.DIRECT_CAPTURE]: { id: _.DIRECT_CAPTURE, label: 'Direct capture' },
  [_.AUTHENTICATE]: { id: _.AUTHENTICATE, label: 'Authenticate' },
};
